var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLghtningFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 72,
    viewBox: "0 0 63 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M41.6654 71.5C53.4471 71.5 62.998 61.9491 62.998 50.1674C62.998 38.3857 53.4471 28.8347 41.6654 28.8347C29.8837 28.8347 20.3328 38.3857 20.3328 50.1674C20.3328 61.9491 29.8837 71.5 41.6654 71.5Z",
    fill: "#4AD3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3329 66.8312L20.9994 43.4986L2.33337 36.4989L34.999 1.5L30.3325 24.8326L48.9985 31.8324L16.3329 66.8312Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLghtningFast);
export default __webpack_public_path__ + "static/media/lghtning-fast.0fdcf72796b373ccd507b1c99561b55a.svg";
export { ForwardRef as ReactComponent };